import { render, staticRenderFns } from "./FaturaKarlilik.vue?vue&type=template&id=28116328&scoped=true"
import script from "./FaturaKarlilik.vue?vue&type=script&lang=js"
export * from "./FaturaKarlilik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28116328",
  null
  
)

export default component.exports